import React from "react";
import styles from "../components/laymanComp_css/LaymanPage13.module.css";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/krishna.json";
export default function LaymanPage13() {
  return (
    <>
<Common_html BlockData={BlockData} />
    </>
  );
}
